import type { OrganizationEntity, InlineImage } from '../core/types'

export function buildSchemaOrganization(options: {
  id: string
  name: string
  url?: string
  sameAs?: string[]
  logo?: { url: string; caption?: string }
}): OrganizationEntity {
  const logo: InlineImage | undefined = options.logo
    ? {
        '@type': 'ImageObject',
        url: options.logo.url,
        ...(options.logo.caption ? { caption: options.logo.caption } : {})
      }
    : undefined

  return {
    '@type': 'Organization',
    '@id': options.id,
    name: options.name,
    ...(options.url ? { url: options.url } : {}),
    ...(options.sameAs?.length ? { sameAs: options.sameAs } : {}),
    ...(logo ? { logo } : {})
  }
}
